import * as S from './style';

function BlackLayer({position}) {
    return (
        <S.BlackLayer position={position} id="first"/>
    )
}

export default BlackLayer;